import React from 'react';
import TableStructure from '../../../components/listView/TableStructure';
import { useHotelsList } from '../../contexts/HotelsListContext';
import HotelRow from './HotelRow';
import { hotelsTableColumns } from '../../utils/hotelsListUtils';

const HotelsTable = () => {
    const { items, isLoading, sortDir, sortedBy, sortByField, handleScroll } =
        useHotelsList();

    return (
        <TableStructure
            onScroll={handleScroll}
            columns={hotelsTableColumns}
            sortedBy={sortedBy}
            sortDir={sortDir}
            sortByField={sortByField}
            isLoading={isLoading}
            items={items}
            rowComponent={props => <HotelRow hotel={props.item} />}
        />
    );
};

export default HotelsTable;
